import { createAsyncThunk } from "@reduxjs/toolkit";

import endpoints from "../endpoints";
import { sendRequest } from "../requests-browser";

export const fetchFileKinds = createAsyncThunk("fileKinds/fetchAll", async () => {
  const response = await sendRequest(endpoints.GET_FILE_KINDS);
  return response.getKindsList();
});
